module.exports = "/images/zh-Hant.svg";